/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TimeTrackingTaskType {
    WORK_PACKAGE = 'work_package',
    MANAGER_ACCOUNT = 'manager_account',
    TRAINING = 'training',
}
